import React from "react";
import { Inbox } from "lucide-react";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  testId?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  testId,
}) => {
  return (
    <div
      data-testid={testId ?? "empty-state"}
      className="sg-card px-8 py-14 flex flex-col items-center text-center"
    >
      <div className="h-12 w-12 rounded-full bg-[color:var(--sg-muted-bg)] flex items-center justify-center mb-4">
        {icon ?? <Inbox className="h-5 w-5 text-[color:var(--sg-muted)]" strokeWidth={1.75} />}
      </div>
      <h3 className="font-display text-lg font-semibold text-[color:var(--sg-fg)] tracking-tight">
        {title}
      </h3>
      {description && (
        <p className="text-sm text-[color:var(--sg-muted)] mt-1.5 max-w-md">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
};
